import axios from 'axios';
import moment from "moment";

export const VALIDATE_HMAC_BEGIN = 'VALIDATE_HMAC_BEGIN';
export const VALIDATE_HMAC_SUCCESS = 'VALIDATE_HMAC_SUCCESS';
export const VALIDATE_HMAC_FAILURE = 'VALIDATE_HMAC_FAILURE';

export const validateHmacBegin = () => ({
    type: VALIDATE_HMAC_BEGIN
});

export const validateHmacSuccess = (value) => ({
    type: VALIDATE_HMAC_SUCCESS,
    payload: value
});

export const validateHmacFailure = (error) => ({
    type: VALIDATE_HMAC_FAILURE,
    payload: error
});

export const validateHmac = (webappurlForms, accessToken, parameters) => {
    return dispatch => {
        const options = {
            headers: {
                'Authorization': "Bearer " + accessToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        };

        dispatch(validateHmacBegin());

        return axios.post(webappurlForms + "/api/myCASA/Forms/validateHmac/v1", {paymentParamters:  parameters}, options)
            .then(response => {
                if (!response.data.wasSuccessful || !response.data.hmacValid || !response.data.paymentSuccess) {
                    return dispatch(validateHmacFailure(response.errors));
                }

                return dispatch(validateHmacSuccess(response));
            })
            .catch(error => {
                return dispatch(validateHmacFailure(error))
            });
    };
}


